import { BehaviorSubject } from "rxjs";

function createCookieStorage() {
  const setItem = (key: string, value: string) => {
    try {
      localStorage.setItem(key, value);
    } catch (e) {
      try {
        localStorage.removeItem(key);
      } catch (_) {}
    }
  };

  const getItem = (key: string) => localStorage.getItem(key);

  const removeItem = (key: string) => localStorage.removeItem(key);

  const clear = () => {
    localStorage.clear();
  };

  const init = (key: string, observer: BehaviorSubject<any>) => {
    const lastDataString = getItem(key);

    if (lastDataString) {
      try {
        observer.next(JSON.parse(lastDataString));
      } catch (_) {}
    }

    observer.subscribe((next) => {
      try {
        setItem(key, JSON.stringify(next));
      } catch (_) {}
    });
  };

  return {
    setItem,
    getItem,
    removeItem,
    clear,
    init,
  };
}

const CookieStorage = createCookieStorage();

export default CookieStorage;
